import { DatabaseChangeType } from '@databases/types/redux';

export const yjsHandlerIgnoreMap = new Set<DatabaseChangeType>([
  // not stored in yjs
  DatabaseChangeType.SET_NAME,
  DatabaseChangeType.RESET_NAME,
  DatabaseChangeType.SET_SPACE,
  DatabaseChangeType.SET_IS_GLOBAL,
  // unused
  DatabaseChangeType.UPDATE_FIELD,
  // not possible
  DatabaseChangeType.RESET_FIELD,
  DatabaseChangeType.RESET_FIELD_NAME,
  DatabaseChangeType.UNDELETE_FIELD,
  DatabaseChangeType.RESET_VALUE,
  DatabaseChangeType.UNDELETE_ENTRY,
]);
